/* =========================================================================
   COOKEHOUSE: ch-dual-gallery-swiper.js
   Stable dual gallery + variant sync.

   2026 regression fix:
   - Theme now dispatches `variant:change` on the product form
   - The event does not bubble
   - So we listen in the capture phase and safely re-init from fresh DOM

   Keeps:
   - ProductGallery wrapper compatibility
   - Bike / moto toggle support
   - Thumbnail sync
   - GLightbox support
   ========================================================================= */

(function () {
  var DEBUG = false;
  var STORAGE_KEY = 'cookehouse_galleryMode';
  var lightbox = null;
  var variantListenerAttached = false;
  var sectionListenerAttached = false;
  var initTimer = null;

  var wrapperGlobal = null;
  var datasetGlobal = null;
  var currentMode = null;
  var currentVariantId = null;

  function log() {
    if (DEBUG) console.log.apply(console, arguments);
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function detectMode() {
    var url = location.href.toLowerCase();
    if (url.indexOf('motorcycle') !== -1) return 'moto';

    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'bike' || stored === 'moto') return stored;
    } catch (e) {}

    var ref = (document.referrer || '').toLowerCase();
    if (ref.indexOf('motorcycle') !== -1 || ref.indexOf('motorbike') !== -1) return 'moto';
    if (ref.indexOf('bicycle') !== -1 || ref.indexOf('bike') !== -1) return 'bike';

    return 'bike';
  }

  function storeMode(mode) {
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {}
  }

  function collectSlides(wrapper) {
    var slides = qsa('.ch-main-swiper .swiper-slide', wrapper).map(function (slide) {
      return {
        id: String(slide.getAttribute('data-media-id') || ''),
        tag: slide.getAttribute('data-ch-tag') || '',
        featured: slide.getAttribute('data-featured') === 'true',
        html: slide.innerHTML
      };
    });

    var thumbs = qsa('.ch-thumbs-swiper .swiper-slide', wrapper).map(function (thumb) {
      return {
        id: String(thumb.getAttribute('data-media-id') || ''),
        tag: thumb.getAttribute('data-ch-tag') || '',
        featured: thumb.getAttribute('data-featured') === 'true',
        html: thumb.innerHTML
      };
    });

    return {
      slides: slides,
      thumbs: thumbs
    };
  }

  function splitSets(dataset) {
    var bike = [];
    var moto = [];
    var neutral = [];
    var featuredItem = dataset.slides.find(function (slide) {
      return slide.featured;
    }) || null;

    dataset.slides.forEach(function (slide) {
      if (featuredItem && slide.id === featuredItem.id) return;

      if (slide.tag === 'bike') {
        bike.push(slide);
      } else if (slide.tag === 'moto') {
        moto.push(slide);
      } else {
        neutral.push(slide);
      }
    });

    return {
      featured: featuredItem,
      bike: bike,
      moto: moto,
      neutral: neutral
    };
  }

  function findThumbForSlide(dataset, slideItem) {
    if (!dataset || !dataset.thumbs || !slideItem) return null;

    return dataset.thumbs.find(function (thumb) {
      return thumb.id === slideItem.id;
    }) || null;
  }

  function injectVariantIntoPack(dataset, pack, variantId) {
    if (!variantId) return pack;

    variantId = String(variantId);

    var exists =
      (pack.featured && String(pack.featured.id) === variantId) ||
      pack.items.some(function (item) {
        return String(item.id) === variantId;
      });

    if (exists) return pack;

    var variantItem = dataset.slides.find(function (slide) {
      return String(slide.id) === variantId;
    });

    if (!variantItem) {
      log('Variant media not found for id', variantId);
      return pack;
    }

    pack.items = [variantItem].concat(pack.items);
    return pack;
  }

  function renderSet(wrapper, dataset, set) {
    var mainWrapper = qs('.ch-main-swiper .swiper-wrapper', wrapper);
    var thumbWrapper = qs('.ch-thumbs-swiper .swiper-wrapper', wrapper);

    if (!mainWrapper || !thumbWrapper) return;

    mainWrapper.innerHTML = '';
    thumbWrapper.innerHTML = '';

    var renderedIds = new Set();

    function addSlide(item) {
      if (!item || !item.id || renderedIds.has(item.id)) return;
      renderedIds.add(item.id);

      var featuredAttr = item.featured ? ' data-featured="true"' : '';
      var tagAttr = item.tag ? ' data-ch-tag="' + item.tag + '"' : '';

      mainWrapper.insertAdjacentHTML(
        'beforeend',
        '<div class="swiper-slide" data-media-id="' + item.id + '"' + featuredAttr + tagAttr + '>' +
          item.html +
        '</div>'
      );

      var thumb = findThumbForSlide(dataset, item);
      var thumbHtml = thumb ? thumb.html : item.html;
      var thumbFeaturedAttr = thumb && thumb.featured ? ' data-featured="true"' : (item.featured ? ' data-featured="true"' : '');
      var thumbTagAttr = thumb && thumb.tag ? ' data-ch-tag="' + thumb.tag + '"' : (item.tag ? ' data-ch-tag="' + item.tag + '"' : '');

      thumbWrapper.insertAdjacentHTML(
        'beforeend',
        '<button type="button" class="swiper-slide ch-thumb" data-media-id="' + item.id + '"' + thumbFeaturedAttr + thumbTagAttr + '>' +
          thumbHtml +
        '</button>'
      );
    }

    if (set.featured) addSlide(set.featured);
    set.items.forEach(addSlide);
  }

  function destroySwipers(wrapper) {
    if (!wrapper || !wrapper.__chSwipers) return;

    try {
      if (wrapper.__chSwipers.main) {
        wrapper.__chSwipers.main.destroy(true, true);
      }
    } catch (e) {}

    try {
      if (wrapper.__chSwipers.thumbs) {
        wrapper.__chSwipers.thumbs.destroy(true, true);
      }
    } catch (e) {}

    wrapper.__chSwipers = null;
  }

  function syncActiveThumb(wrapper, mainSwiper) {
    if (!wrapper || !mainSwiper || !mainSwiper.slides) return;

    var active = mainSwiper.slides[mainSwiper.activeIndex];
    if (!active) return;

    var activeId = String(active.getAttribute('data-media-id') || '');

    qsa('.ch-thumbs-swiper .swiper-slide', wrapper).forEach(function (thumb) {
      var thumbId = String(thumb.getAttribute('data-media-id') || '');
      thumb.classList.toggle('swiper-slide-thumb-active', thumbId === activeId);
    });
  }

  function initSwipers(wrapper) {
    var thumbsEl = qs('.ch-thumbs-swiper', wrapper);
    var mainEl = qs('.ch-main-swiper', wrapper);

    if (!thumbsEl || !mainEl || typeof Swiper === 'undefined') return null;

    var thumbs = new Swiper(thumbsEl, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      freeMode: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: qs('.ch-thumbs-nav--next', wrapper),
        prevEl: qs('.ch-thumbs-nav--prev', wrapper)
      }
    });

    var main = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: qs('.ch-nav--next', wrapper),
        prevEl: qs('.ch-nav--prev', wrapper)
      },
      thumbs: {
        swiper: thumbs
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      },
      on: {
        init: function () {
          syncActiveThumb(wrapper, this);
        },
        slideChange: function () {
          syncActiveThumb(wrapper, this);
        }
      }
    });

    thumbsEl.onclick = function (event) {
      var thumb = event.target.closest('.swiper-slide[data-media-id]');
      if (!thumb) return;

      var mediaId = String(thumb.getAttribute('data-media-id') || '');
      var slides = qsa('.ch-main-swiper .swiper-slide', wrapper);
      var index = slides.findIndex(function (slide) {
        return String(slide.getAttribute('data-media-id') || '') === mediaId;
      });

      if (index >= 0) {
        main.slideTo(index);
      }
    };

    mainEl.onclick = function (event) {
      var link = event.target.closest('a.glightbox');
      if (link) link.click();
    };

    wrapper.__chSwipers = {
      main: main,
      thumbs: thumbs
    };

    return wrapper.__chSwipers;
  }

  function initLightbox() {
    try {
      if (lightbox) {
        lightbox.destroy();
        lightbox = null;
      }

      lightbox = GLightbox({
        selector: '.glightbox',
        touchNavigation: true,
        loop: true,
        zoomable: false,
        autoplayVideos: false,
        moreText: '',
        slideEffect: 'fade'
      });
    } catch (e) {
      console.error('COOKEHOUSE: Lightbox init failed.', e);
    }
  }

  function updateToggleUI(wrapper, mode) {
    var toggle = qs('.ch-gallery-toggle', wrapper);
    if (!toggle) return;

    qsa('.ch-gallery-toggle__btn', toggle).forEach(function (btn) {
      var isActive = btn.getAttribute('data-ch-gallery') === mode;

      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');

      var label = isActive ? btn.dataset.activeLabel : btn.dataset.inactiveLabel;
      if (label) btn.textContent = label;
    });
  }

  function applyMode(wrapper, dataset, mode) {
    if (!wrapper || !dataset) return;

    var parts = splitSets(dataset);

    var pack = {
      featured: parts.featured,
      items: mode === 'moto'
        ? parts.neutral.concat(parts.moto)
        : parts.neutral.concat(parts.bike)
    };

    if (currentVariantId) {
      pack = injectVariantIntoPack(dataset, pack, currentVariantId);
    }

    destroySwipers(wrapper);
    renderSet(wrapper, dataset, pack);
    initSwipers(wrapper);
    initLightbox();
  }

  function goToMediaId(wrapper, mediaId) {
    if (!wrapper || !wrapper.__chSwipers || !wrapper.__chSwipers.main || !mediaId) return;

    var main = wrapper.__chSwipers.main;
    mediaId = String(mediaId);

    var index = -1;

    for (var i = 0; i < main.slides.length; i++) {
      var slide = main.slides[i];
      if (slide && String(slide.getAttribute('data-media-id') || '') === mediaId) {
        index = i;
        break;
      }
    }

    if (index >= 0) {
      main.slideTo(index);
      syncActiveThumb(wrapper, main);
    }
  }

  function bindToggle(wrapper) {
    var toggle = qs('.ch-gallery-toggle', wrapper);
    if (!toggle) return;

    qsa('.ch-gallery-toggle__btn', toggle).forEach(function (btn) {
      btn.onclick = function () {
        var nextMode = btn.getAttribute('data-ch-gallery');
        if (!nextMode || nextMode === currentMode) return;
        if (!datasetGlobal) return;

        currentMode = nextMode;
        storeMode(currentMode);
        updateToggleUI(wrapper, currentMode);
        applyMode(wrapper, datasetGlobal, currentMode);

        if (currentVariantId) {
          goToMediaId(wrapper, currentVariantId);
        }
      };
    });
  }

  function initCurrentWrapper() {
    var wrapper = qs('.ch-gallery-wrapper');
    if (!wrapper) return;

    wrapperGlobal = wrapper;
    datasetGlobal = collectSlides(wrapper);

    var hasBike = datasetGlobal.slides.some(function (slide) {
      return slide.tag === 'bike';
    });

    var hasMoto = datasetGlobal.slides.some(function (slide) {
      return slide.tag === 'moto';
    });

    var toggle = qs('.ch-gallery-toggle', wrapper);

    destroySwipers(wrapper);

    if (!(hasBike && hasMoto)) {
      if (toggle) toggle.hidden = true;
      initSwipers(wrapper);
      initLightbox();
      return;
    }

    if (toggle) toggle.hidden = false;

    currentMode = detectMode();
    storeMode(currentMode);
    updateToggleUI(wrapper, currentMode);
    applyMode(wrapper, datasetGlobal, currentMode);
    bindToggle(wrapper);
  }

  function scheduleReinit(delay) {
    window.clearTimeout(initTimer);

    initTimer = window.setTimeout(function () {
      initCurrentWrapper();

      if (wrapperGlobal && currentVariantId) {
        goToMediaId(wrapperGlobal, currentVariantId);
      }
    }, delay || 0);
  }

  function handleVariantChange(evt) {
    var variant = evt && evt.detail && evt.detail.variant;
    if (!variant) return;

    currentVariantId = variant.featured_media ? String(variant.featured_media.id) : null;

    // Theme has already replaced ProductGallery markup before dispatching variant:change.
    // Small defer keeps us safely behind any internal view-transition work.
    scheduleReinit(80);
  }

  function attachVariantListener() {
    if (variantListenerAttached) return;

    // IMPORTANT:
    // Theme dispatches `variant:change` on the product form, not always on document.
    // The event does not bubble, so we must listen in capture phase.
    document.addEventListener('variant:change', handleVariantChange, true);

    variantListenerAttached = true;
  }

  function attachSectionListener() {
    if (sectionListenerAttached) return;

    document.addEventListener('shopify:section:load', function () {
      scheduleReinit(50);
    });

    sectionListenerAttached = true;
  }

  function boot() {
    if (typeof Swiper === 'undefined') {
      console.error('COOKEHOUSE: Swiper missing.');
      return;
    }

    initCurrentWrapper();
    initLightbox();
    attachVariantListener();
    attachSectionListener();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.setTimeout(boot, 200);
    });
  } else {
    window.setTimeout(boot, 200);
  }
})();